
import { fnLocalizeFilter, ILocale } from "../../../../services/localize.service";
import { IColumn } from "../../../UI/CustomTable/components/Columns/Columns";


interface IGetColumns {
	locale: ILocale;
}

export const getColumns = ( { locale }: IGetColumns ): IColumn[] => {
	return [
		{
			field: 'accountId',
			label: fnLocalizeFilter( locale, '_lang.module.setting.users.titleAccountId' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'accountRemark',
			label: fnLocalizeFilter( locale, '_lang.module.setting.users.titleAccountRemark' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'lastName',
			label: fnLocalizeFilter( locale, '_lang.module.setting.users.titleLastName' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'firstName',
			label: fnLocalizeFilter( locale, '_lang.module.setting.users.titleFirstName' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'cardId',
			label: fnLocalizeFilter( locale, '_lang.module.cards.titleID' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		},
		{
			field: 'mobile',
			label: fnLocalizeFilter( locale, '_lang.module.cards.titlePhone' ),
			formatHeader: 'default',
			cell: { format: 'default' },
			align: 'center',
			alignData: 'center'
		}
	]
}
